import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  type?: "info" | "error" | "success";
}

export const StatusMessage: React.FC<Props> = ({ type = "info", children }) => {
  return <div className={`status-message ${type}`}>{children}</div>;
};
